// extracted by mini-css-extract-plugin
export default {"wrap":"Pagination_wrap__Phvvl","page":"Pagination_page__fm3g4"};